/** Header listens for this to refresh the unread-messages badge. */
export const MESSAGES_CHANGED_EVENT = 'hs:messages-changed';

export const notifyMessagesChanged = () => {
  window.dispatchEvent(new Event(MESSAGES_CHANGED_EVENT));
};

export const formatBadgeCount = (count) => (count > 99 ? '99+' : String(count));
